var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"primary":"","outline":""},on:{"click":_vm.openDialog}},[_vm._v(" Add Tags ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }